/* istanbul ignore file */

import { connect } from 'react-redux';

import { ReduxApplicationState } from 'src/redux/combinedReducer';
import { Breadcrumb } from '../components/Breadcrumb';
import * as actions from '../modules/actions';
import { selectBreadcrumbData, selectBreadcrumbJSONLDSchema } from '../modules/selectors';

export const mapStateToProps = (state: ReduxApplicationState) => ({
  JSONLDSchema: selectBreadcrumbJSONLDSchema(state),
  breadcrumbItems: selectBreadcrumbData(state),
});

export const mapDispatchToProps = {
  onBreadcrumbLinkClick: actions.breadcrumbLinkClick,
};

export const BreadcrumbContainer = connect(mapStateToProps, mapDispatchToProps)(Breadcrumb);
